import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';

import ChemicalProgramStore from 'app/stores/chemical.program';
import ChemicalProductsComponent from 'app/admin/components/chemical.products';

import { ListCtrl, DetailCtrl } from './ctrls';

import mainTpl from './templates/main.html';
import detailTpl from './templates/details.html';

import tableSectionTpl from './templates/table.section.html';
import detailSectionTpl from './templates/detail.section.html';

@Module({
    name: 'app.admin.chemical.products',
    modules: [
        BaseRoute,
        ChemicalProgramStore,
        ChemicalProductsComponent,
    ],
})
@State({
    name: 'r.in.top.admin.company.chemicals',
    url: '/chemicals',
    template: mainTpl,
    abstract: '.list',
    data: {
        permissions: {
            only: [
                'main.view_chemicalprogram',
            ],
        },
    },
    ncyBreadcrumb: {
        skip: true,
        parent: 'r.in.top.admin.company',
    },
})
@State({
    name: 'r.in.top.admin.company.chemicals.list',
    url: '?search',
    views: {
        tableView: {
            template: tableSectionTpl,
            controller: ListCtrl,
        },
        detailsView: {
            template: detailSectionTpl,
            controller: DetailCtrl,
        },
    },
    resolve: {
        $object: function () {
            return null;
        },
    },
    ncyBreadcrumb: {
        label: 'Chemical Programs',
    },
})
@State({
    name: 'r.in.top.admin.company.chemicals.list.program',
    url: '/{objectId:int}',
    ncyBreadcrumb: {
        skip: true,
    },
    template: '<ui-view/>',
    resolve: {
        $object: function($stateParams, ChemicalProgramStore) {
            return ChemicalProgramStore.get($stateParams.objectId);
        },
    },
    abstract: '.detail',
})
@State({
    name: 'r.in.top.admin.company.chemicals.list.program.detail',
    url: '/details',
    controller: DetailCtrl,
    template: detailTpl,
    as: 'vmc',
    ncyBreadcrumb: {
        label: '{{ vmc.object.name }}',
    },
})
export default class States { }



// WEBPACK FOOTER //
// ./src/app/admin/chemical_programs/routing.js